/**
 * PulsingOrb Component
 * Animated orb with pulsing effect and glow
 */

import React from 'react';
import './loading.css';

export const PulsingOrb: React.FC = () => {
  return (
    <div className="ai360-pulsing-orb">
      <div className="ai360-orb-core" />
      <div className="ai360-orb-ring ai360-orb-ring-1" />
      <div className="ai360-orb-ring ai360-orb-ring-2" />
      <div className="ai360-orb-ring ai360-orb-ring-3" />
    </div>
  );
};
